module.exports = __webpack_public_path__ + "static/media/LogoDE.b449a8d7.svg";